import React, { useState } from "react";

import Servicesbanner from '../Servicesbanner';
import Servicescontent from '../Servicescontent';
import Testimonials from '../Testimonials';
import Servicesstep from '../Servicesstep';

const Realestateinvestmentpayments = () => {

  const [steps, setSteps] = useState([
    { 
      stepNumber: 1,
      stepbadgeText: "Step 1", 
      steptitle: "Submit a Payment Request", 
      steptext: "Click “Get a Payment Quote” and fill out a quick form with property details, payment amount, and currency preferences.",
      stepimageSrc: "../Images/number-1.png"
    },
    { 
      stepNumber: 2,
      stepbadgeText: "Step 2", 
      steptitle: "Receive a Customized Quote", 
      steptext: "Our team calculates the exchange rate, transaction fees, and final amount to be sent, then provides a transparent quote for your review.",
      stepimageSrc: "../Images/number-2.png"
    },
    { 
      stepNumber: 3,
      stepbadgeText: "Step 3", 
      steptitle: "Approve and Complete Payment", 
      steptext: "Review and approve the quote if satisfied. Follow our secure instructions to complete payment and upload any required documents.",
      stepimageSrc: "../Images/number-3.png"
    },
    { 
      stepNumber: 4,
      stepbadgeText: "Step 4", 
      steptitle: "Payment Processing and Transfer Execution", 
      steptext: "Once payment is received, we process the funds, convert currency if needed, and transfer the amount to the property seller or management account.",
      stepimageSrc: "../Images/number-4.png"
    },
    { 
      stepNumber: 5,
      stepbadgeText: "Step 5", 
      steptitle: "Confirmation and Receipt", 
      steptext: "Upon transaction completion, you’ll receive a confirmation email with transaction details and a receipt for your records.",
      stepimageSrc: "../Images/number-5.png"
    }
  ]);

  return (
    <>
      <Servicesbanner 
        title="Real Estate" 
        highlight="Investment Payments" 
        />
      <Servicescontent 
        conttitle="Service Overview" 
        content={<><p>Our real estate investment payments service provides an efficient and secure way to transfer funds for real estate investments in Canada or internationally. We handle currency conversion, payment processing, and documentation to streamline property purchases, rental payments, and other real estate transactions. With competitive exchange rates, clear fees, and regulatory compliance, we make it easy for you to securely invest in real estate across borders.</p></>}
        buttonlink="#"
        label="Get a Payment Quote"
      />
      <Servicesstep 
        steps={steps} 
      />
      <Testimonials />
    </>
  );
}

export default Realestateinvestmentpayments;
